// feedbackLuzes.js

let statusDasLuzesFlex35 = [];
let statusDasLuzesFlex8 = [];

export async function getLuzesStatusFlex35() {

  try {
    const response = await fetch('https://terrazza.cmd-automacao.com/statusLuzesFlex35');
    const data = await response.json();
    statusDasLuzesFlex35 = [...data];
  } catch (error) {
    console.error("Erro na requisição HTTP GET:", error);
  }

  return statusDasLuzesFlex35;
}

export async function getLuzesStatusFlex8() {

  try {
    const response = await fetch('https://terrazza.cmd-automacao.com/LuzesFlex8');
    const data = await response.json();
    statusDasLuzesFlex8 = [...data];
  } catch (error) {
    console.error("Erro na requisição HTTP GET:", error);
  }

  return statusDasLuzesFlex8;
}

export { statusDasLuzesFlex35, statusDasLuzesFlex8 };